import { createContext } from "react";
import { useState } from "react";

const ExpertExpertisesContext = createContext({
  farmsIds: null,
  gardensIds: null,
  earthenGreenHouseIds: null,
  hydroponicGreenHouseIds: null,
  liveStockIds: null,
  veterinaryIds: null
});

export const ExpertExpertisesProvider = ({ children }) => {
  const [farmsIds, setFarmsIds] = useState(null);
  const [gardensIds, setGardensIds] = useState(null);
  const [earthenGreenHouseIds, setEarthenGreenHouseIds] = useState(null);
  const [hydroponicGreenHouseIds, setHydroponicGreenHouseIds] = useState(null);
  const [liveStockIds, setLiveStockIds] = useState(null);
  const [veterinaryIds, setVeterinaryIds] = useState(null);

  const farmsIdsActions = (data) => {
    setFarmsIds(data);
  };
  const gardensIdsActions = (data) => {
    setGardensIds(data);
  };
  const earthenGreenHouseIdsActions = (data) => {
    setEarthenGreenHouseIds(data);
  };
  const hydroponicGreenHouseIdsActions = (data) => {
    setHydroponicGreenHouseIds(data);
  };
  const liveStockIdsAction = (data) => {
    setLiveStockIds(data)
  };
  const veterinaryIdsAction = (data) => {
    setVeterinaryIds(data)
  };
  const resetExpertises = () => {
    setFarmsIds(null);
    setGardensIds(null)
    setEarthenGreenHouseIds(null)
    setHydroponicGreenHouseIds(null)
    setLiveStockIds(null)
    setVeterinaryIds(null)
  }

  return (
    <ExpertExpertisesContext.Provider
      value={{
        farmsIds,
        gardensIds,
        earthenGreenHouseIds,
        hydroponicGreenHouseIds,
        liveStockIds,
        veterinaryIds,
        farmsIdsActions,
        gardensIdsActions,
        earthenGreenHouseIdsActions,
        hydroponicGreenHouseIdsActions,
        liveStockIdsAction,
        veterinaryIdsAction,
        resetExpertises
      }}
    >
      {children}
    </ExpertExpertisesContext.Provider>
  );
};

export default ExpertExpertisesContext;
